/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthCadastroRouteImport } from './routes/_auth/cadastro'
import { Route as AuthCadastrosRouteImport } from './routes/_auth/cadastros'
import { Route as AuthPerfilRouteImport } from './routes/_auth/perfil'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCadastroRoute = AuthCadastroRouteImport.update({
  id: '/cadastro',
  path: '/cadastro',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCadastrosRoute = AuthCadastrosRouteImport.update({
  id: '/cadastros',
  path: '/cadastros',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPerfilRoute = AuthPerfilRouteImport.update({
  id: '/perfil',
  path: '/perfil',
  getParentRoute: () => AuthRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/cadastro': typeof AuthCadastroRoute
  '/cadastros': typeof AuthCadastrosRoute
  '/perfil': typeof AuthPerfilRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/cadastro': typeof AuthCadastroRoute
  '/cadastros': typeof AuthCadastrosRoute
  '/perfil': typeof AuthPerfilRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/login': typeof LoginRoute
  '/_auth/cadastro': typeof AuthCadastroRoute
  '/_auth/cadastros': typeof AuthCadastrosRoute
  '/_auth/perfil': typeof AuthPerfilRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/login' | '/cadastro' | '/cadastros' | '/perfil'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/login' | '/cadastro' | '/cadastros' | '/perfil'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/login'
    | '/_auth/cadastro'
    | '/_auth/cadastros'
    | '/_auth/perfil'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/cadastro': {
      id: '/_auth/cadastro'
      path: '/cadastro'
      fullPath: '/cadastro'
      preLoaderRoute: typeof AuthCadastroRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/cadastros': {
      id: '/_auth/cadastros'
      path: '/cadastros'
      fullPath: '/cadastros'
      preLoaderRoute: typeof AuthCadastrosRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/perfil': {
      id: '/_auth/perfil'
      path: '/perfil'
      fullPath: '/perfil'
      preLoaderRoute: typeof AuthPerfilRouteImport
      parentRoute: typeof AuthRoute
    }
  }
}

interface AuthRouteChildren {
  AuthCadastroRoute: typeof AuthCadastroRoute
  AuthCadastrosRoute: typeof AuthCadastrosRoute
  AuthPerfilRoute: typeof AuthPerfilRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthCadastroRoute: AuthCadastroRoute,
  AuthCadastrosRoute: AuthCadastrosRoute,
  AuthPerfilRoute: AuthPerfilRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
